import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=d3849590&scoped=true&"
import script from "./SiteFooter.vue?vue&type=script&lang=js&"
export * from "./SiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=d3849590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3849590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3849590')) {
      api.createRecord('d3849590', component.options)
    } else {
      api.reload('d3849590', component.options)
    }
    module.hot.accept("./SiteFooter.vue?vue&type=template&id=d3849590&scoped=true&", function () {
      api.rerender('d3849590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/SiteFooter.vue"
export default component.exports